<template>
    <section :class="applicationClass">
        <header :class="pageHeaderClass">
            <div class="page-header__container">
                <mobile-navigation/>
                <logo></logo>
                <desktop-navigation/>
            </div>
        </header>

        <main :class="mainClasses">
            <router-view></router-view>
        </main>

        <footer class="page-footer">
            <div :class="footerContentClasses">
                <page-footer></page-footer>
            </div>
            <section class="footer-bottom">
                <logo/>
                <small>© Newport Collection AB. 2024. VAT number SE556760011801 | Newport Official Online Store</small>
            </section>
        </footer>
    </section>
</template>
<script>
import { defineComponent, unref } from 'vue';
import Logo from '@components/App/Logo.vue';
import DesktopNavigation from '@components/App/DesktopNavigation.vue';
import { useAppStore } from '@stores/App';
import MobileNavigation from '@components/App/MobileNavigation.vue';
import PageFooter from '@components/Layout/PageFooter.vue';
import { kebabize } from '@services/Common';

export default defineComponent({
    components: { PageFooter, MobileNavigation, DesktopNavigation, Logo },
    computed: {
        pageHeaderClass() {
            const app = useAppStore();
            const open = app.burgerMenuOpen ? 'np-open' : 'np-close';
            return [ unref(app.getBreakpoints().active()), 'page-header', open ];
        },
        footerContentClasses() {
            const app = useAppStore();
            return [ 'footer-content', unref(app.getBreakpoints().active()) ];
        },
        applicationClass() {
            const app = useAppStore();
            return [ 'application', ...app.getPageClasses() ];
        },
        mainClasses() {
            return [ `main-${this.path}` ];
        }
    },
    data() {
        return { path: null };
    },
    watch: {
        $route(to, from) {
            this.path = to.name?.split('.')?.map((str) => {
                return kebabize(str);
            }).join('-');
        }
    }
});
</script>
<style lang="scss" scoped>
.application {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
}

.page-header {
    display: flex;
    justify-content: center;
    align-items: center;

    &__container {
        display: grid;
        justify-content: center;
        align-items: center;
        padding: 1rem;
        max-width: var(--container-max-width);
        margin: auto;
        width: 100%;
    }
}

.sm,
.md {
    .page-header__container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
    }
}

.page-footer {
    display: grid;
    margin-top: 40px;
    min-height: 300px;
    background: #ffffff;
}

.footer-content {
    display: grid;
    grid-template-columns: 1fr;
    padding: 60px 40px;
    flex-direction: column;
    margin: 0 auto;
    max-width: var(--container-max-width);
    width: 100%;
    background: var(--theme-bg);
    transition: background-color var(--transition-duration), color var(--transition-duration);

    &.sm {
        display: flex;
        align-items: center;
    }
}

.footer-bottom {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;
    padding: 3rem;

    small {
        color: #999;
        font-size: 12px;
        line-height: 1.75;
        text-align: center;
    }
}

.inverted-logo {
    max-width: 140px;
}
</style>
